/**
 * 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Message } from './message';
import { Event } from './event';


export interface MailoPostCallbackInfo { 
    message?: Message;
    event?: Event;
}

